(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-correction.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-correction.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.core.log.getLogger('module:lyckoplatsen');
const {
  swe,
  sweRectangleBounds,
  mapDefaults,
  createMap,
  calculateCumulativeSumDoubledUpToIndex,
  calculateSouthCoordinate,
  isPointInsideSweden,
  findClosestCoord,
  get3dPinIcon,
  checkDuplicateWagersLocations,
  getSouthCoordinate
} = svs.tur.lyckoplatsen.map;
const formatCurrency = svs.utils.format.Currency;
const {
  CONSTANTS: {
    CORRECTION_STEP
  }
} = svs.lyckoplatsen.components.shared_constants;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
function getCorrectionMapHandler() {
  let map;
  let options = {};
  let result;
  let wagers;
  let sweRec;
  const eventHandlers = {};
  const gridCoords = [];
  const rads = []; 
  const leafletWinCircles = [];
  const leafletWinCirclesGrowing = [];
  const leafletWagers = [];
  const leafletWagersDistances = [];
  const triggeredWagers = new Set();
  let winCoord;
  let tlMain;

  let _isDestroying = false;

  const svgRenderer = leaflet.svg({
    padding: 0.85
  });
  return {
    createMap(mapOptions, mapResult) {
      let mapWagers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      let evtHandlers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options, () => {
        var _eventHandlers$showMa;
        return (_eventHandlers$showMa = eventHandlers.showMapErrorDialog) === null || _eventHandlers$showMa === void 0 ? void 0 : _eventHandlers$showMa.call(eventHandlers);
      });
      wagers = mapWagers;
      result = mapResult;
      this.setupWinCoord();
      if (mapWagers.length) {
        this.setupWagers(mapWagers);
      }
      Object.assign(eventHandlers, evtHandlers);
      sweRec = leaflet.rectangle(sweRectangleBounds, {
        color: 'yellow',
        fillOpacity: 0.6,
        weight: 1,
        renderer: svgRenderer
      });
      map.fitBounds(sweRec.getBounds(), {
        padding: [12, 12],
        animate: false
      });
      tlMain = gsap.timeline({
        paused: true
      });
      this.initiateDrawMapExperience();
      return map;
    },
    setupWinCoord() {
      const formattedLat = parseFloat(result.location.latitude.replace(',', '.')).toFixed(6);
      const formattedLng = parseFloat(result.location.longitude.replace(',', '.')).toFixed(6);
      winCoord = [formattedLat, formattedLng];
    },
    setupWagers(mapWagers) {
      var _wagers;
      const unique = checkDuplicateWagersLocations(mapWagers);
      wagers = unique;
      if ((_wagers = wagers) !== null && _wagers !== void 0 && _wagers.length) {
        wagers.map(wager => {
          const wagerLat = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.'));
          const wagerLng = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.'));
          return leafletWagersDistances.push(Math.trunc(map.distance(winCoord, [wagerLat, wagerLng])));
        });
      }
    },
    removeMap() {
      if (_isDestroying) {
        return;
      }
      _isDestroying = true;

      try {
        if (tlMain) {
          tlMain.eventCallback('onComplete', null);
          tlMain.pause(0);
          tlMain.kill();
          tlMain = null;
        }
      } catch (_unused) {
        logger.debug('Correction map, GSAP not removed properly');
      }

      try {
        if (map) {
          map.off('resize', this.updateGradientBgOffset);
          map.off('viewreset', this.updateGradientBgOffset);
        }
      } catch (_unused2) {
        logger.debug('Correction map, map listeners not removed properly');
      }

      try {
        leafletWagers.forEach(w => {
          try {
            if (w && w.isPopupOpen && w.isPopupOpen()) {
              w.closePopup();
            }
          } catch (err) {
            logger.debug('Correction map, error closing wager popup:', err);
          }
        });
      } catch (err) {
        logger.debug('Correction map, error processing wager popups:', err);
      }

      try {
        if (map && typeof map.closePopup === 'function') {
          const hasPopup = map._popup;
          if (hasPopup && typeof hasPopup.close === 'function') {
            map.closePopup();
          }
        }
      } catch (err) {
        logger.debug('Correction map, error closing map popup:', err);
      }
      try {
        if (map && typeof map.closeTooltip === 'function') {
          const hasTooltip = map._tooltip;
          if (hasTooltip && typeof hasTooltip.close === 'function') {
            map.closeTooltip();
          }
        }
      } catch (err) {
        logger.debug('Correction map, error closing map tooltip:', err);
      }

      try {
        leafletWagers.forEach(w => {
          try {
            if (w && w.remove) {
              w.remove();
            }
          } catch (err) {
            logger.debug('Correction map, error removing wager:', err);
          }
        });
        leafletWagers.length = 0;
        triggeredWagers.clear();
      } catch (err) {
        logger.debug('Correction map, error clearing wagers:', err);
      }

      try {
        leafletWinCircles.forEach(c => {
          try {
            if (c && c.remove) {
              c.remove();
            }
          } catch (err) {
            logger.debug('Correction map, error removing win circle:', err);
          }
        });
        leafletWinCircles.length = 0;
      } catch (err) {
        logger.debug('Correction map, error clearing win circles:', err);
      }

      try {
        leafletWinCirclesGrowing.forEach(c => {
          try {
            if (c && c.remove) {
              c.remove();
            }
          } catch (err) {
            logger.debug('Correction map, error removing growing circle:', err);
          }
        });
        leafletWinCirclesGrowing.length = 0;
      } catch (err) {
        logger.debug('Correction map, error clearing growing circles:', err);
      }

      try {
        if (sweRec && sweRec.remove) {
          sweRec.remove();
        }
        sweRec = null;
      } catch (err) {
        logger.debug('Correction map, error removing Sweden rectangle:', err);
      }

      try {
        var _options;
        const container = (_options = options) !== null && _options !== void 0 && _options.nodeId ? document.getElementById(options.nodeId) : null;
        container === null || container === void 0 || container.querySelectorAll('.js-dynamically-added, .gsap-map-gradient, .gsap-dot, .gsap-dot-winner, .pin-wager-correction, .label').forEach(el => el.remove());
      } catch (_unused3) {
        logger.debug('Correction map, dom elements removed properly');
      }

      try {
        if (map) {
          var _map$stop, _map;
          (_map$stop = (_map = map).stop) === null || _map$stop === void 0 || _map$stop.call(_map);
          map.off();
          map.remove();
          map = null;
        }
      } catch (_unused4) {
        logger.debug('Correction map, the map is not removed properly');
      }

      options = {};
      result = null;
      wagers = [];
      winCoord = null;
      gridCoords.length = 0;
      rads.length = 0;
      leafletWagersDistances.length = 0;
      _isDestroying = false;
    },
    setDefaults() {
      var _wagers2;
      const tl = gsap.timeline();
      if (document.querySelector('.gsap-heart-count')) {
        tl.set('.gsap-heart-count', {
          opacity: 0,
          scale: 0.75
        });
      }
      if (document.querySelector('.gsap-pin-wager-correction')) {
        tl.set('.gsap-pin-wager-correction', {
          opacity: 0
        });
      }
      if ((_wagers2 = wagers) !== null && _wagers2 !== void 0 && _wagers2.length) {
        wagers.forEach((_, i) => tl.set(".gsap-pin-wager-".concat(i, " .pin-image"), {
          opacity: 0,
          scale: 0
        }));
      }
      if (document.querySelector('.gsap-win-location')) {
        tl.set('.gsap-win-location', {
          opacity: 0,
          scale: 0
        });
      }
      if (document.querySelector('.gsap-location-name')) {
        tl.set('.gsap-location-name', {
          opacity: 0
        });
      }
      if (document.querySelector('.gsap-location-name-child')) {
        tl.set('.gsap-location-name-child', {
          opacity: 0,
          height: 0
        });
      }
      if (document.querySelector('.gsap-top-win')) {
        tl.set('.gsap-top-win', {
          opacity: 0,
          top: '-50px'
        });
      }
      tlMain.add(tl, '>');
    },
    updateGradientBgOffset() {
      var _getComputedStyle;
      const gradientEl = document.querySelector('.gsap-map-gradient');
      const mapPaneEl = document.querySelector('.leaflet-map-pane');
      const transform = (_getComputedStyle = getComputedStyle(mapPaneEl)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.transform;
      if (gradientEl && transform && transform !== 'none') {
        const matrix = transform.match(/matrix.*\((.+)\)/)[1].split(', ');
        const tx = parseFloat(matrix[4]) || 0;
        const ty = parseFloat(matrix[5]) || 0;
        gradientEl.style.transform = "translate(".concat(-tx, "px, ").concat(-ty, "px)");
      }
    },
    addBackground() {
      if (map) {
        const gradient = document.querySelector('.gsap-map-gradient');
        if (!gradient) {
          const tgaElement = document.querySelector('.lp-map-correction .leaflet-map-pane');
          const newDiv = document.createElement('div');
          newDiv.className = 'map-gradient gsap-map-gradient js-dynamically-added';
          tgaElement.appendChild(newDiv);
        }
        this.updateGradientBgOffset();
        map.on('resize', this.updateGradientBgOffset);
        map.on('viewreset', this.updateGradientBgOffset);
      }
    },
    addDots() {
      let skipCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let adjustRadiuses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      let orgCoords;
      let lat;
      let lng;
      const rows = 57;
      const cols = 26;
      const latDiff = (sweRectangleBounds[0][0] - sweRectangleBounds[1][0]) / rows;
      const lngDiff = (sweRectangleBounds[0][1] - sweRectangleBounds[1][1]) / cols;

      for (let i = 0; i < rows; i++) {
        if (i === 0) {
          lat = sweRectangleBounds[0][0] - i * latDiff - latDiff / 2;
        } else {
          const distFromStart = calculateCumulativeSumDoubledUpToIndex(rads, i - 1).pop();
          const newLat = calculateSouthCoordinate(orgCoords, distFromStart);
          lat = newLat[0];
        }

        const lng1 = sweRectangleBounds[0][1] - Number(lngDiff) - lngDiff / 2;
        const lng2 = sweRectangleBounds[0][1] - 2 * lngDiff - lngDiff / 2;
        const rowRadius = map.distance([lat, lng1], [lat, lng2]) / 2;
        rads.push(Number(rowRadius.toFixed(0)));

        for (let j = 0; j < cols; j++) {
          lng = sweRectangleBounds[0][1] - j * lngDiff - lngDiff * 0.4; 

          if (i === 0) {
            orgCoords = [lat, lng];
          } 

          if (skipCheck || isPointInsideSweden([lat, lng], swe.features[0].geometry.coordinates)) {
            const dotLat = Number(lat.toFixed(6));
            const dotLng = Number(lng.toFixed(6));
            const dotName = "gsap-dot-sweden gsap-dot-".concat(i);
            leaflet.circle([dotLat, dotLng], {
              radius: adjustRadiuses ? rads[i] * 0.84 : rads[0],
              fillColor: '#2073E5',
              fillOpacity: 1,
              weight: 0,
              className: "gsap-dot ".concat(dotName, " gsap-hide"),
              renderer: svgRenderer
            }).addTo(map);
            gridCoords.push({
              lat: dotLat,
              lng: dotLng,
              radius: Number(rowRadius.toFixed(0))
            });
          }
        }
      }
    },
    addWinnerDot() {
      const closest = findClosestCoord(winCoord[0], winCoord[1], gridCoords);
      leaflet.circle([closest.lat, closest.lng], {
        radius: closest.radius * 0.84,
        fillColor: '#16FFAB',
        fillOpacity: 1,
        weight: 0,
        className: "gsap-dot gsap-dot-winner gsap-hide",
        renderer: svgRenderer
      }).addTo(map);
    },
    addWinnerLocationName() {
      const myIcon = leaflet.divIcon({
        className: 'lp-draw-location-name-container',
        html: "<div class=\"lp-draw-location-name-container\">\n                <div class=\"lp-draw-win-location gsap-win-location lp-win gsap-hide\">\n                  <span>Vinnande plats</span>\n                  ".concat(result.location.county, "\n                </div>\n              </div>"),
        iconSize: [0, 0]
      });
      const leafletLabel = leaflet.marker(winCoord, {
        icon: myIcon,
        keyboard: false
      });
      leafletLabel.addTo(map);
    },
    addPin() {
      const icon = get3dPinIcon({
        className: 'gsap-pin-winner gsap-hide-png animate-image',
        color: 'green'
      });
      leaflet.marker(winCoord, {
        icon
      }).addTo(map);
    },
    addWagers() {
      var _wagers3;
      if (!((_wagers3 = wagers) !== null && _wagers3 !== void 0 && _wagers3.length)) {
        return;
      }
      wagers.forEach((wager, index) => {
        const icon = get3dPinIcon({
          color: 'red',
          className: "pin-wager-correction gsap-pin-wager-correction gsap-pin-wager-".concat(index, " animate-image"),
          count: wager.wagerMultiplayed
        });
        const formattedLat = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.')).toFixed(6);
        const formattedLng = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.')).toFixed(6);
        const pin = leaflet.marker([formattedLat, formattedLng], {
          icon
        });
        pin.setZIndexOffset((index + 1000) * ((wager === null || wager === void 0 ? void 0 : wager.wagerMultiplayed) || 1));
        pin.addTo(map);
        leafletWagers.push(pin);
      });
    },
    addWinnerCircles() {
      leafletWinCircles.length = 0;
      leafletWinCirclesGrowing.length = 0;

      result.distribution.slice(1).forEach((circle, index) => {
        const leafletCircle = leaflet.circle(winCoord, {
          radius: circle.distanceMeters,
          fillColor: 'transparent',
          weight: 4,
          className: "gsap-winner-circle gsap-hide",
          renderer: svgRenderer
        });
        leafletCircle.addTo(map);
        leafletWinCircles.push(leafletCircle);
        const leafletCircleGrowing = leaflet.circle(winCoord, {
          className: "growing-winner-circle gsap-growing-winner-circle gsap-growing-circle-".concat(index, " gsap-hide"),
          radius: index === 0 ? 0 : result.distribution.slice(1)[index - 1].distanceMeters,
          fillColor: 'transparent',
          weight: 4,
          renderer: svgRenderer
        });
        leafletWinCirclesGrowing.push(leafletCircleGrowing);
        leafletCircleGrowing.addTo(map);
      });
    },
    addWinnerCircleLabels() {
      const labels = [];
      map.createPane('labels');
      map.getPane('labels').style.zIndex = 401;
      const groups = result.distribution.slice(1);
      groups.forEach((circle, index) => {
        const labelDistance = circle.distanceMeters * 0.98;
        const labelCoord = getSouthCoordinate(winCoord, Math.trunc(labelDistance));
        const winsTxt = "".concat(formatCurrency(circle.winners), " ").concat(circle.winners === 1 ? 'vinst' : 'vinster');
        const myIcon = leaflet.divIcon({
          className: "label label-".concat(groups.length - 1 - index, " ").concat(circle.distanceMeters < 200 ? 'label-below' : '', " gsap-label-circle-").concat(index, " gsap-hide"),
          html: "<div>".concat(winsTxt, " \xE0 ").concat(formatCurrency(circle.amountSek.slice(0, -3)), " kr<span>").concat(svs.lyckoplatsen.utils.format.formatDistance(circle.distanceMeters), "</span></div>"),
          iconSize: [0, 0]
        });
        const leafletLabel = leaflet.marker(labelCoord, {
          icon: myIcon,
          pane: 'labels',
          keyboard: false
        });
        leafletLabel.addTo(map);
        labels.push(leafletLabel);
      });
    },
    mapFitBoundsSweden() {
      if (productMapping.isLyckoplatsenPrimary(result.productId)) {
        return;
      }
      const tl = gsap.timeline({
        duration: 0.1,
        onStart: () => map.fitBounds(sweRec.getBounds(), {
          padding: [12, 12],
          animate: false
        })
      });
      tlMain.add(tl, '>');
    },
    animateTopWinText() {
      const tl = gsap.timeline();
      tl.to('.gsap-top-win', {
        opacity: 1,
        top: '0px',
        duration: 1,
        ease: 'power4.out'
      }, '>');
      tlMain.add(tl, '<');
    },
    animateDotsIn() {
      const dots = gsap.utils.toArray('.gsap-dot-sweden');
      const tl = gsap.timeline({
        onStart: () => map.fitBounds(sweRec.getBounds(), {
          padding: [12, 12],
          animate: false
        })
      });
      if (productMapping.isLyckoplatsenSecondary(result.productId)) {
        tl.add(() => {}, 0.5);
      }
      tl.to(dots, {
        fill: '#1047B8',
        opacity: 1,
        ease: 'none',
        stagger: {
          each: 0.001
        }
      });
      tlMain.add(tl, '>');
    },
    animateDotsGreen() {
      const tl = gsap.timeline();
      tl.to('.gsap-dot-sweden', {
        opacity: 1,
        fill: '#16FFAB',
        duration: 1,
        ease: 'power1.out'
      }, '>');
      tlMain.add(tl, '>');
    },
    animateDotsOut() {
      const dots = gsap.utils.toArray('.gsap-dot-sweden');
      const shuffled = gsap.utils.shuffle(dots);
      const tl = gsap.timeline();
      tl.set('.gsap-dot-winner', {
        opacity: 1
      });
      shuffled.forEach(dot => {
        const d = 1 + Math.random() * 5.5;
        tl.to(dot, {
          fill: '#1047B8',
          duration: 2,
          ease: 'power1.inOut'
        }, d);
      });
      tlMain.add(tl, '>');
    },
    mapZoomInWinner(map) {
      const tl = gsap.timeline({
        duration: 3,
        onStart: () => {
          const bounds = leafletWinCircles[0].getBounds();
          map.flyToBounds(bounds, {
            animate: true,
            duration: 3,
            easeLinearity: 0.1,
            noMoveStart: false
          });
        }
      });
      tl.to('.gsap-dot', {
        opacity: 0,
        delay: 0,
        duration: 1,
        ease: 'power4.out'
      }, '<').to('.gsap-map-gradient', {
        opacity: 0.72,
        delay: 0,
        duration: 2.5,
        ease: 'power4.out'
      }, '<');
      tlMain.add(tl, '>');
    },
    animatePin() {
      const tl = gsap.timeline();
      tl.add(gsap.timeline()).set(".gsap-pin-winner .pin-image", {
        opacity: 0,
        scale: 0
      }).to(".gsap-pin-winner .pin-image", {
        opacity: 1,
        scale: 1,
        duration: 0.75,
        ease: 'power4.out'
      });
      tlMain.add(tl, '>');
    },
    animateLocation() {
      const tl = gsap.timeline();
      tl.set('.gsap-win-location', {
        transformOrigin: 'top center'
      });
      tl.to('.gsap-win-location', {
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: 'power4.out'
      }, '>+0.8');
      tlMain.add(tl, '<');
    },
    animatePinColorHideLocation() {
      const tl = gsap.timeline();
      tl.to('.gsap-map-gradient', {
        opacity: 0,
        duration: 2,
        ease: 'power4.out'
      }, '<').to('.gsap-win-location', {
        opacity: 0,
        duration: 1.2,
        ease: 'power4.out'
      }, '<');
      tlMain.add(tl, '>+1');
    },
    animateWagers() {
      var _wagers4;
      if (!((_wagers4 = wagers) !== null && _wagers4 !== void 0 && _wagers4.length)) {
        return;
      }
      const tl = gsap.timeline();
      tl.set('.gsap-pin-wager-correction', {
        opacity: 1
      });
      wagers.forEach((_, i) => {
        tl.to(".gsap-pin-wager-".concat(i, " .pin-image"), {
          opacity: 1,
          scale: 1,
          duration: 0.5,
          ease: 'power4.out'
        }, '>');
      });
      tlMain.add(tl, '>');
    },
    animateTopWinLocationName() {
      const tl = gsap.timeline({
        onStart: () => {
          const pinEl = document.querySelector('.pin-heart');
          if (!pinEl) {
            return;
          }
          const parentTop = pinEl.offsetParent.getBoundingClientRect().top;
          const pinY = pinEl.getBoundingClientRect().bottom;
          gsap.set('.lp-draw > .lp-draw-location-name-container', {
            y: pinY - parentTop
          });
        },
        onComplete: () => {
          var _eventHandlers$automa;
          return (_eventHandlers$automa = eventHandlers.automatedStepUpdate) === null || _eventHandlers$automa === void 0 ? void 0 : _eventHandlers$automa.call(eventHandlers, CORRECTION_STEP.DISTANCE);
        }
      });
      if (document.querySelector('.gsap-location-name-child')) {
        tl.to('.gsap-location-name-child', {
          opacity: 1,
          height: '24px',
          duration: 1,
          ease: 'power4.out'
        }, '<');
      }
      tlMain.add(tl, '-=1');
    },
    mapSetView(map) {
      const tl = gsap.timeline({
        duration: 0.1,
        onStart: () => {
          const bounds = leafletWinCircles[0].getBounds();
          map.fitBounds(bounds, {
            animate: false
          });
        }
      });
      tlMain.add(tl, '>');
    },
    animateWagerPin(wagerIndex) {
      var _pin$openPopup;
      const el = document.querySelector(".gsap-pin-wager-".concat(wagerIndex, " .pin-image"));
      if (!el) {
        return;
      }
      const pin = leafletWagers[wagerIndex];
      pin === null || pin === void 0 || (_pin$openPopup = pin.openPopup) === null || _pin$openPopup === void 0 || _pin$openPopup.call(pin);
      const tl = gsap.timeline();
      tl.set(".gsap-pin-wager-".concat(wagerIndex, " .pin-image"), {
        opacity: 1,
        scale: 0.5
      });
      tl.to(".gsap-pin-wager-".concat(wagerIndex, " .pin-image"), {
        opacity: 1,
        scale: 1.5,
        duration: 1.2,
        ease: 'elastic(2, 0.3)'
      }).to(".gsap-pin-wager-".concat(wagerIndex, " .pin-image"), {
        scale: 1,
        duration: 2.5,
        ease: 'back.out(1.2)',
        onStart: () => {
          const pyro = el.querySelector('.pyro');
          if (pyro) {
            const pyroType = svs.core.detect.breakpoint.current === 'xs' || svs.core.detect.formfactor.mobile() ? 'pyro-active' : 'pyro-big-active';
            pyro.classList.add(pyroType);
          }
        }
      }, '<');
      tl.play();
    },
    checkAndAnimateWagers(currentRadius) {
      if (!leafletWagersDistances.length) {
        return;
      }
      for (let i = 0; i < leafletWagersDistances.length; i++) {
        const dist = leafletWagersDistances[i];
        if (currentRadius >= dist && !triggeredWagers.has(i)) {
          this.animateWagerPin(i);
          triggeredWagers.add(i);
        }
      }
    },
    animateZoomStagger() {
      const flyDur = 1.5;
      result.distribution.slice(1).forEach((circle, index) => {
        const tl = gsap.timeline({
          onStart: () => {
            const bounds = leafletWinCircles[index].getBounds();
            map.flyToBounds(bounds, {
              duration: flyDur
            });
          }
        });
        tl.to({}, {
          duration: flyDur
        });
        const target = {
          radius: 0
        };
        const throttled = _.throttle(() => this.checkAndAnimateWagers(target.radius), 300);
        tl.to(target, {
          duration: 1.5,
          radius: circle.distanceMeters,
          onUpdate: () => {
            leafletWinCirclesGrowing[index].setRadius(target.radius);
            throttled();
          },
          ease: 'power4.out'
        }, '>');
        tl.to(".gsap-growing-circle-".concat(index), {
          duration: 1.5,
          opacity: 1,
          ease: 'power1.out'
        }, '<');
        tl.to(".gsap-label-circle-".concat(index), {
          delay: 1.25,
          opacity: 1,
          duration: 0.5,
          ease: 'power1.out'
        }, '<');
        tl.to(".gsap-label-circle-".concat(index), {
          delay: 1.75,
          opacity: 0,
          duration: 0.5,
          ease: 'power1.out'
        }, '<');
        tlMain.add(tl, '>');
      });
    },
    jumpToResult() {
      let jump = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      const tl = gsap.timeline({
        duration: 0.5,
        onComplete: () => {
          var _wagers5;
          if (!((_wagers5 = wagers) !== null && _wagers5 !== void 0 && _wagers5.length) || jump) {
            var _eventHandlers$automa2;
            (_eventHandlers$automa2 = eventHandlers.automatedStepUpdate) === null || _eventHandlers$automa2 === void 0 || _eventHandlers$automa2.call(eventHandlers, CORRECTION_STEP.RESULT);
          }
        }
      });
      tl.to('.lp-draw', {
        duration: 0.5,
        opacity: 0,
        ease: 'power1.out'
      }, '>');
      tlMain.add(tl, '>');
    },
    mapZoomInWagers(map) {
      var _wagers6;
      if (!((_wagers6 = wagers) !== null && _wagers6 !== void 0 && _wagers6.length)) {
        return;
      }
      const bounds = leaflet.latLngBounds();
      const biggest = leafletWinCircles[leafletWinCircles.length - 1];
      bounds.extend(biggest.getBounds());
      leafletWagers.forEach(m => bounds.extend(m.getLatLng()));
      const tl = gsap.timeline({
        duration: 3,
        onStart: () => {
          map.flyToBounds(bounds, {
            animate: true,
            duration: 1.5,
            easeLinearity: 0.1,
            noMoveStart: false
          });
        }
      });
      tlMain.add(tl, '>');
    },
    resetWagerPins() {
      if (leafletWagers !== null && leafletWagers !== void 0 && leafletWagers.length) {
        leafletWagers.forEach(p => p.closePopup());
        triggeredWagers.clear();
      }
    },
    initiateDrawMapExperience() {
      this.addBackground();
      this.addDots();
      this.addWinnerDot();
      this.addWinnerLocationName();
      this.addPin();
      this.addWagers();
      this.addWinnerCircles();
      this.addWinnerCircleLabels();

      this.setDefaults();

      this._labelPlace();
      this.animateDotsIn();
      this.mapFitBoundsSweden();
      this.animateWagers();
      this.animateDotsGreen();
      this.animateTopWinText();
      this.animateDotsOut();
      this.mapZoomInWinner(map);
      this.animatePin();
      this.animateLocation();
      this.animatePinColorHideLocation();
      this.animateTopWinLocationName();

      this._labelDistance();
      this.mapSetView(map);
      this.animateZoomStagger();
      this.jumpToResult(true);
    },
    tlPlay() {
      tlMain.play();
    },
    tlPause() {
      tlMain.pause();
    },
    tlKill() {
      this.resetWagerPins();
      if (tlMain) {
        tlMain.eventCallback('onComplete', null);
        tlMain.clear();
        tlMain.kill();
        tlMain = null;
      }
      document.querySelectorAll('.js-dynamically-added').forEach(el => el.remove());
      if (map) {
        map.off('resize', this.updateGradientBgOffset);
        map.off('viewreset', this.updateGradientBgOffset);
      }
    },
    tlSeek(seek) {
      this.resetWagerPins();
      if (seek === 2) {
        tlMain.seek('place');
      } else if (seek === 3) {
        tlMain.seek('distance');
      }
    },
    _labelPlace() {
      tlMain.add('place', '+=0');
    },
    _labelDistance() {
      tlMain.add('distance', '+=0');
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getCorrectionMapHandler
});

 })(window);